module.exports = __webpack_public_path__ + "media/images/sp/stores/common/appeal_01-30b248e7e568352515ccab3418164fe4.jpg";